import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import type { DbWake } from '../hooks/useDbWake';

function mmss(s: number): string {
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}

/** Shows only while the CRM database is starting (or could not be started). Renders nothing when ready. */
export function DbWakeBanner({ wake }: { wake: DbWake }): React.ReactElement | null {
  if (wake.state === 'ready' || wake.state === 'checking') return null;
  const stuck = wake.state === 'unknown' || wake.state === 'timeout';
  return (
    <div
      role={stuck ? 'alert' : 'status'}
      className={`flex items-start gap-2 rounded-lg border px-4 py-3 text-sm ${
        stuck ? 'border-fail-soft bg-fail-soft text-fail' : 'border-warn-soft bg-warn-soft text-warn'
      }`}
    >
      {stuck ? (
        <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" aria-hidden="true" />
      ) : (
        <Loader2 className="h-4 w-4 mt-0.5 flex-shrink-0 animate-spin" aria-hidden="true" />
      )}
      <span>
        {wake.message}
        {!stuck && <span className="ml-1 tabular-nums text-warn">({mmss(wake.elapsedS)})</span>}
      </span>
    </div>
  );
}
